import { Models } from "./index.js";

export function Compare() {
	return `
    ${Models()}                                                                                      		
  `;
}